module.exports = __webpack_public_path__ + "img/thisIsNotHappening.53d8f947.png";